import { GameVars } from "../../GameVars";
import { GameConstants } from "../../GameConstants";
import { TeamButton } from "./TeamButton";

export class TeamSelectionState extends Phaser.State {

    public static currentInstance: TeamSelectionState;

    public create(): void {

        TeamSelectionState.currentInstance = this;

        this.stage.disableVisibilityChange = true;

        const layerBackground = this.add.image(0, 0, "lawn-background");
        layerBackground.scale.setTo(1.65, 1.65 * GameVars.scaleY);
        layerBackground.anchor.setTo(.5, 0);
        layerBackground.x = GameConstants.GAME_WIDTH / 2;
        layerBackground.y = - 320;

        this.addTeamsButtons(GameVars.currentTournamentName);
    }

    public shutdown(): void {
        
        TeamSelectionState.currentInstance = null;
                    
        super.shutdown();
    }

    private addTeamsButtons(tournamentName: string): void {

        let i = 0;
        let j = 0;

        let py: number;
        let deltaY: number;

        py = 70;
        deltaY = 139;
        
        for (let k = 0; k < GameVars.teamsData.length; k++) {

            var teamData: TeamData = GameVars.teamsData[k];

            if (teamData.selectable) {

                let teamButton = new TeamButton(this.game, teamData);
                teamButton.x = i * 125 + 75;
                teamButton.y = j * deltaY + py;
                this.add.existing(teamButton);

                for (let l = 0; l < teamData.tournaments.length; l++) {
                    if (teamData.tournaments[l] === tournamentName) {
                        teamButton.activate();
                        teamButton.currentTournament = tournamentName;
                        break;
                    }
                }

                if ( i < 5 ) {
                    i ++;
                } else {
                    i = 0;
                    j++;
                }
            }
        }
    }
}
